module.exports = __webpack_public_path__ + "img/dibu2.8ff788b2.png";